import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { ExtendedAccountResponse } from '../store/types';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

interface RoleProtectedRouteProps {
  allowedRoles: string[];
  children: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Fixed: Check for both null and undefined
  if (!auth.account || auth.account === null) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles, children }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Use auth.account.user.role per AccountResponse, fallback for store mismatch
  const account = auth.account as ExtendedAccountResponse | null;
  const rawRole = account?.user?.role || account?.role;
  const userRole = rawRole?.trim().toLowerCase();

  if (!auth.account || auth.account === null) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!userRole) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!allowedRoles.map((role) => role.toLowerCase()).includes(userRole)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};